import React from 'react';
import ReactDOM from 'react-dom';
import './style/style.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);


reportWebVitals();
